<div class="modal_platform">
  <div class="backdrop" (click)="onClose()"></div>
  <div class="platform_container">
    <div class="cloudimage-360" data-keys data-spin-reverse data-autoplay data-speed="170" data-drag-speed="170" data-bottom-circle
    id="gurkha-suv"></div>
  </div>
</div>